// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"k7-z"};